import React from 'react';
import {noop} from 'lodash';

import {PinInput} from '../../PinInput';

import {useCreatePinInput} from './CreatePinInput.hook';

interface CreatePinInputProps {
  theme: string;
  textVariant: string;
  createTitle: Record<string, any>;
  confirmTitle: Record<string, any>;
  onClose: () => void;
  onFirstLogin: boolean;
  onSuccess: () => void;
}

export const CreatePinInput: React.FC<CreatePinInputProps> = ({
  theme = 'light',
  textVariant = 'heading',
  createTitle = {},
  confirmTitle = {},
  onClose = noop,
  onFirstLogin = false,
  onSuccess = noop,
}) => {
  const {getText, onInputPin, onInputComplete, pinStatus} = useCreatePinInput({
    createTitle,
    confirmTitle,
    onClose,
    onFirstLogin,
    onSuccess,
  });

  return (
    <PinInput
      autoFocus={true}
      theme={theme}
      textVariant={textVariant}
      title={getText()}
      onInputPin={onInputPin}
      onInputComplete={onInputComplete}
      status={pinStatus}
      onClose={onClose}
      onFirstLogin={onFirstLogin}
      onSuccess={onSuccess}
    />
  );
};
